import React, { useState } from "react";
import Icon from "../ui/Icon";
import { getAvatarColors } from "../utils/avatar";

export default function ParticipantsPanel({ list = [], onProfileClick }) {
  const [panelShow, setPanelShow] = useState(false);

  return (
    <>
      {!panelShow && (
        <div className="gm-chat-shell">
          <div className="gm-chat-panel">
            <div className="gm-chat-header">
              <div className="gm-chat-headerLeft">
                <div className="gm-chat-headerIcon">
                  <Icon name="people" />
                </div>
                <div>
                  <div className="gm-chat-title">People</div>
                  <div className="gm-chat-subtitle">
                    {list.length} participants
                  </div>
                </div>
              </div>

              <button
                onClick={() => setPanelShow(true)}
                className="jt-mobileDrawerClose"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="gm-search-wrap">
              <input
                type="text"
                placeholder="Search participants"
                className="gm-search-input"
              />
            </div>

            <div className="gm-participants-list">
              {list.map((p) => {
                const [c1, c2] = getAvatarColors(p.name);

                const roleLabel =
                  p.role === "host"
                    ? "Host"
                    : p.role === "speaker"
                    ? "Speaker"
                    : "";

                return (
                  <div key={p.id} className="gm-user-row">
                    <div className="gm-user-left">
                      <div
                        className="gm-user-avatar"
                        style={{
                          background: `linear-gradient(135deg, ${c1}, ${c2})`,
                        }}
                      >
                        {p.image ? (
                          <img src={p.image} alt={p.name} />
                        ) : (
                          <span>{(p.name?.[0] || "?").toUpperCase()}</span>
                        )}

                        {p.isLive && <div className="gm-online-indicator" />}
                      </div>

                      <div className="gm-user-info">
                        <div className="gm-user-top">
                          <h4
                            title={`View ${p.name}'s profile`}
                            style={{ cursor: "pointer" }}
                            onClick={() => onProfileClick?.(p)}
                          >
                            {p.isLocal ? `${p.name} (You)` : p.name}
                          </h4>

                          {roleLabel && (
                            <span
                              className={`gm-role-badge ${
                                p.role === "host"
                                  ? "host"
                                  : p.role === "speaker"
                                  ? "speaker"
                                  : ""
                              }`}
                            >
                              {roleLabel}
                            </span>
                          )}
                        </div>

                        <p className="gm-user-subtitle">
                          {p.isMuted ? "Muted" : "Speaking"}
                        </p>
                      </div>
                    </div>

                    <div className="gm-user-actions">
                      <button
                        className={`gm-action-btn ${p.isMuted ? "off" : "on"}`}
                      >
                        {p.isMuted ? (
                          <Icon name="micOff" />
                        ) : (
                          <Icon name="mic" />
                        )}
                      </button>

                      <button
                        className={`gm-action-btn ${
                          p.isCameraOff ? "off" : "on"
                        }`}
                      >
                        {p.isCameraOff ? (
                          <Icon name="camOff" />
                        ) : (
                          <Icon name="cam" />
                        )}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
